(function(){
  function init(root){
    if (!root || root.dataset.lpInit === '1') return;
    root.dataset.lpInit = '1';

    // ============== HERO CAROUSEL ==============
    (function(){
      const track = root.querySelector('.lp-hero-track');
      if (!track) return;
      const slides = track.querySelectorAll('.lp-hero-slide');
      const dotsWrap = root.querySelector('.lp-hero-dots');
      const thumbs = root.querySelectorAll('.lp-hero-thumb');
      if (!dotsWrap || slides.length === 0) return;

      dotsWrap.innerHTML = '';
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        if (i === 0) b.classList.add('lp-active');
        b.addEventListener('click', () => go(i));
        dotsWrap.appendChild(b);
      });
      const dots = dotsWrap.querySelectorAll('button');
      let cur = 0;

      function syncIndicators(){
        dots.forEach((d, k) => d.classList.toggle('lp-active', k === cur));
        thumbs.forEach((t, k) => t.classList.toggle('lp-active', k === cur));
      }
      function go(i){
        cur = (i + slides.length) % slides.length;
        track.scrollTo({ left: cur * track.clientWidth, behavior: 'smooth' });
        syncIndicators();
      }

      const prev = root.querySelector('.lp-hero-arrow.lp-prev');
      const next = root.querySelector('.lp-hero-arrow.lp-next');
      if (prev) prev.addEventListener('click', () => go(cur - 1));
      if (next) next.addEventListener('click', () => go(cur + 1));

      let scrollTimer = null;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== cur){ cur = i; syncIndicators(); }
        }, 60);
      });
      thumbs.forEach(t => t.addEventListener('click', () => go(parseInt(t.dataset.idx, 10) || 0)));
    })();

    // ============== BUNDLE PICKER ==============
    const items = root.querySelectorAll('.lp-bundle-item');
    const cta = root.querySelector('.lp-cta');
    if (items.length === 0 || !cta) return;

    function getQ(it){ return parseInt(it.querySelector('.lp-qty').textContent, 10) || 0; }
    function setQ(it, n){ it.querySelector('.lp-qty').textContent = Math.max(0, n); }
    function fmt(n){ return 'R$ ' + n.toFixed(2).replace('.', ','); }
    function discountFor(q){ if (q >= 3) return 0.15; if (q === 2) return 0.10; return 0; }

    // Clickable ladder steps
    root.querySelectorAll('.lp-ladder-step').forEach(step => {
      step.addEventListener('click', e => {
        e.preventDefault();
        const target = parseInt(step.dataset.step, 10);
        const arr = Array.from(items);
        let totalQty = arr.reduce((s, it) => s + getQ(it), 0);

        if (target > totalQty){
          let need = target - totalQty;
          while (need > 0){
            let best = arr[0], bestQ = getQ(arr[0]);
            arr.forEach(it => { const q = getQ(it); if (q > bestQ){ bestQ = q; best = it; } });
            setQ(best, getQ(best) + 1);
            need--;
          }
        } else if (target < totalQty){
          let excess = totalQty - target;
          while (excess > 0){
            let best = null, bestQ = 0;
            arr.forEach(it => { const q = getQ(it); if (q > bestQ){ bestQ = q; best = it; } });
            if (!best || bestQ <= 0) break;
            setQ(best, bestQ - 1);
            excess--;
          }
        }
        recalc();
      });
    });

    function recalc(){
      let totalQty = 0;
      let subtotal = 0;
      items.forEach(it => {
        const q = getQ(it);
        const price = parseFloat(it.dataset.price) || 0;
        totalQty += q;
        subtotal += q * price;
        it.classList.toggle('lp-has-qty', q > 0);
      });

      // ladder steps — active = highest step reached (or step 1 if nothing yet)
      const reached = Math.max(0, Math.min(3, totalQty));
      const activeStep = reached === 0 ? 1 : reached;
      root.querySelectorAll('.lp-ladder-step').forEach(step => {
        const s = parseInt(step.dataset.step, 10);
        step.classList.remove('lp-active', 'lp-done');
        if (s <= reached) step.classList.add('lp-done');
        if (s === activeStep) step.classList.add('lp-active');
      });

      // progress bar — fills relative to reached step (steps are centered at 0%, 50%, 100%)
      const progress = root.querySelector('.lp-ladder-progress');
      if (progress){
        let pct = 0;
        if (reached === 1) pct = 0;       // anchored at step 1, no fill yet
        else if (reached === 2) pct = 50; // halfway to step 3
        else if (reached >= 3) pct = 100; // full
        progress.style.width = pct + '%';
      }

      // ladder message
      const msg = root.querySelector('.lp-ladder-msg');
      const msgText = root.querySelector('.lp-ladder-msg-text');
      if (msg && msgText){
        msg.classList.remove('lp-done');
        if (totalQty === 0){
          msgText.innerHTML = '🎁 Adicione <b>+1 pote</b> e destrave <b>frete grátis</b>';
        } else if (totalQty === 1){
          msgText.innerHTML = '🎁 Adicione <b>+1 pote</b> e destrave <b>frete grátis + 10% OFF</b>';
        } else if (totalQty === 2){
          msgText.innerHTML = '🎁 Adicione <b>+1 pote</b> e destrave <b>15% OFF</b> + frete grátis';
        } else {
          msg.classList.add('lp-done');
          msgText.innerHTML = '✅ Você destravou o melhor desconto: <b>15% OFF + frete grátis</b>';
        }
      }

      // ladder cta arrow
      const lcta = root.querySelector('.lp-ladder-cta');
      const lctaText = root.querySelector('.lp-ladder-cta-text');
      if (lcta && lctaText){
        if (totalQty >= 3){
          lcta.classList.add('lp-hide');
        } else {
          lcta.classList.remove('lp-hide');
          if (totalQty === 0) lctaText.textContent = 'Adicione potes abaixo para destravar os descontos';
          else if (totalQty === 1) lctaText.innerHTML = 'Adicione +1 pote para destravar <b>10% OFF + frete grátis</b>';
          else lctaText.innerHTML = 'Adicione +1 pote para destravar a <b>melhor oferta</b>';
        }
      }

      // summary
      const disc = discountFor(totalQty);
      const final = subtotal * (1 - disc);
      const sum = root.querySelector('.lp-summary');
      const qtyEl = root.querySelector('.lp-sum-qty');
      const nowEl = root.querySelector('.lp-sum-now');
      const oldEl = root.querySelector('.lp-sum-old');
      const offEl = root.querySelector('.lp-sum-off');
      const metaEl = root.querySelector('.lp-sum-meta');
      const perEl  = root.querySelector('.lp-sum-per');
      const saveEl = root.querySelector('.lp-sum-save');

      if (!sum || !qtyEl || !nowEl || !oldEl || !offEl) return;

      if (totalQty === 0){
        sum.classList.remove('lp-is-active', 'lp-is-discounted');
        qtyEl.textContent = 'Selecione os sabores acima';
        nowEl.textContent = 'R$ 0,00';
        oldEl.classList.add('lp-empty');
        if (metaEl) metaEl.classList.add('lp-empty');
        cta.textContent = 'ESCOLHA OS SABORES';
        cta.style.opacity = '.65';
        cta.style.pointerEvents = 'none';
      } else {
        sum.classList.add('lp-is-active');
        let benefit = '';
        if (totalQty === 1) benefit = '· sem desconto';
        else if (totalQty === 2) benefit = '· frete grátis + 10% OFF';
        else benefit = '· frete grátis + 15% OFF 🎉';
        qtyEl.innerHTML = '<b>' + totalQty + (totalQty === 1 ? ' pote' : ' potes') + '</b> ' + benefit;
        nowEl.textContent = fmt(final);
        cta.textContent = 'COMPRAR AGORA';
        cta.style.opacity = '1';
        cta.style.pointerEvents = 'auto';

        if (metaEl && perEl){
          metaEl.classList.remove('lp-empty');
          perEl.textContent = fmt(final / totalQty) + ' por pote';
          const savings = subtotal - final;
          if (saveEl) saveEl.textContent = savings > 0 ? ' · você economiza ' + fmt(savings) : '';
        }

        if (disc > 0){
          sum.classList.add('lp-is-discounted');
          oldEl.textContent = fmt(subtotal);
          oldEl.classList.remove('lp-empty');
          offEl.textContent = Math.round(disc * 100) + '% OFF';
        } else {
          sum.classList.remove('lp-is-discounted');
          oldEl.classList.add('lp-empty');
        }
      }
    }

    // wire up flavor +/- buttons
    items.forEach(item => {
      const qtyEl = item.querySelector('.lp-qty');
      if (!qtyEl) return;
      const set = n => { qtyEl.textContent = Math.max(0, n); recalc(); };
      const addBtn = item.querySelector('.lp-add-btn');
      const plus = item.querySelector('.lp-plus');
      const minus = item.querySelector('.lp-minus');
      if (addBtn) addBtn.addEventListener('click', () => set(1));
      if (plus) plus.addEventListener('click', () => set((+qtyEl.textContent) + 1));
      if (minus) minus.addEventListener('click', () => set((+qtyEl.textContent) - 1));
    });

    // CTA → /cart/add.js then redirect to checkout
    cta.addEventListener('click', async () => {
      const cartItems = [];
      items.forEach(it => {
        const qty = parseInt(it.querySelector('.lp-qty').textContent, 10) || 0;
        const variantId = parseInt(it.dataset.variantId, 10);
        if (qty > 0 && variantId){
          cartItems.push({
            id: variantId,
            quantity: qty,
            properties: { '_lp_source': 'lp-guday-creatina' }
          });
        }
      });
      if (cartItems.length === 0) return;
      cta.classList.add('lp-loading');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        });
        if (!res.ok){
          const err = await res.json().catch(() => ({}));
          alert(err.description || 'Não foi possível adicionar ao carrinho. Tente novamente.');
          cta.classList.remove('lp-loading');
          return;
        }
        window.location.href = '/checkout';
      } catch (e){
        cta.classList.remove('lp-loading');
        alert('Erro de conexão. Tente novamente.');
      }
    });

    recalc();

    // FAQ accordion
    root.querySelectorAll('.lp-faq-item').forEach(item => {
      const q = item.querySelector('.lp-faq-q');
      if (!q) return;
      q.addEventListener('click', () => {
        const wasOpen = item.classList.contains('lp-open');
        root.querySelectorAll('.lp-faq-item.lp-open').forEach(o => o.classList.remove('lp-open'));
        if (!wasOpen) item.classList.add('lp-open');
      });
    });

    // ============== LAB MODAL ==============
    (function(){
      const trigger = root.querySelector('[data-lab-open]');
      const modal = root.querySelector('.lp-modal');
      if (!trigger || !modal) return;
      const panel = modal.querySelector('.lp-modal__panel');
      const closeEls = modal.querySelectorAll('[data-lab-close]');
      let lastFocus = null;

      function open(){
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('lp-modal-open');
        const closeBtn = modal.querySelector('.lp-modal__close');
        if (closeBtn) closeBtn.focus();
        document.addEventListener('keydown', onKey);
      }
      function close(){
        modal.hidden = true;
        document.body.classList.remove('lp-modal-open');
        document.removeEventListener('keydown', onKey);
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }
      function onKey(e){
        if (e.key === 'Escape'){ e.preventDefault(); close(); }
      }
      // Click outside the panel closes the modal
      function onModalClick(e){
        if (panel && !panel.contains(e.target)) close();
      }

      trigger.addEventListener('click', open);
      closeEls.forEach(el => el.addEventListener('click', close));
      modal.addEventListener('click', onModalClick);
    })();
  }

  function bootstrap(){
    document.querySelectorAll('.lp-guday-wrap').forEach(init);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  // Re-init on theme editor section load
  document.addEventListener('shopify:section:load', bootstrap);
})();
